(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ftf-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ftf-story')) {
  customElements.define('ftf-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.activePanels = new Set();
      this.frame = 0;
      const panels = this.querySelectorAll('[data-ftf-drift]');
      const revealTargets = this.querySelectorAll('.ftf-chapter-copy > *, .ftf-section-heading > *, .ftf-gallery-item, .ftf-community-audio, .ftf-creator, .ftf-community-empty, .ftf-people-intro, .ftf-review, .ftf-review-invitation, .ftf-faq > div > *, .ftf-footer-top > *, .ftf-footer-bottom');
      const setupReveals = () => {
        this.revealObserver?.disconnect();
        revealTargets.forEach(el => el.removeAttribute('data-pending'));
        if (!this.motion || !('IntersectionObserver' in window)) return;
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.removeAttribute('data-pending');
              this.revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: .08 });
        revealTargets.forEach((el, index) => {
          el.classList.add('ftf-reveal');
          el.style.setProperty('--ftf-delay', (index % 3) * 75 + 'ms');
          if (el.getBoundingClientRect().top > innerHeight * .94) {
            el.setAttribute('data-pending', '');
            this.revealObserver.observe(el);
          }
        });
      };
      const syncMotion = () => {
        this.motion = this.dataset.motion === 'true' && !reduce.matches && document.documentElement.dataset.ftfMotion !== 'paused';
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.classList.toggle('ftf-motion-on', this.motion);
        panels.forEach(panel => {
          panel.style.removeProperty('--ftf-drift');
          panel.style.removeProperty('--ftf-tilt');
        });
        setupReveals();
        if (this.motion) this.scheduleMotion();
      };
      this.scheduleMotion = () => {
        if (!this.motion || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.motion) return;
          const total = document.documentElement.scrollHeight - innerHeight;
          this.style.setProperty('--ftf-progress', total > 0 ? Math.max(0, Math.min(1, scrollY / total)) : 0);
          this.activePanels.forEach(panel => {
            const rect = panel.getBoundingClientRect();
            const offset = Math.max(-44, Math.min(44, (innerHeight / 2 - rect.top - rect.height / 2) * .085));
            panel.style.setProperty('--ftf-tilt', Math.max(-1.2, Math.min(1.2, offset * .028)) + 'deg');
            panel.style.setProperty('--ftf-drift', offset + 'px');
          });
        });
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            entry.target.toggleAttribute('data-in-view', entry.isIntersecting);
            if (entry.isIntersecting) this.activePanels.add(entry.target);
            else this.activePanels.delete(entry.target);
          });
          this.scheduleMotion();
        }, { rootMargin: '80px' });
        panels.forEach(panel => this.observer.observe(panel));
      }
      window.addEventListener('scroll', this.scheduleMotion, { passive: true, signal });
      window.addEventListener('resize', this.scheduleMotion, { passive: true, signal });
      reduce.addEventListener('change', syncMotion, { signal });
      document.addEventListener('ftf:motion-change', syncMotion, { signal });
      syncMotion();
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        event.target.removeAttribute('data-pending');
        event.target.querySelectorAll('[data-pending]').forEach(el => el.removeAttribute('data-pending'));
      }, { signal });
      this.addEventListener('focusin', event => {
        event.target.closest('[data-pending]')?.removeAttribute('data-pending');
      }, { signal });
      this.addEventListener('play', event => {
        if (!(event.target instanceof HTMLMediaElement)) return;
        this.querySelectorAll('audio').forEach(audio => { if (audio !== event.target) audio.pause(); });
      }, { capture: true, signal });
      const audios = Array.from(this.querySelectorAll('.ftf-audio-card audio'));
      const reset = audio => {
        const button = audio.parentElement.querySelector('button');
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', button.dataset.playLabel);
        button.querySelector('.ftf-play-icon').textContent = '▶';
      };
      audios.forEach(audio => {
        const button = audio.parentElement.querySelector('button');
        const status = this.querySelector('.ftf-audio-status');
        button.addEventListener('click', async () => {
          if (!audio.paused) { audio.pause(); return; }
          audios.forEach(other => { if (other !== audio) { other.pause(); other.currentTime = 0; } });
          status.textContent = '';
          try { await audio.play(); } catch (error) { if (error.name !== 'AbortError') status.textContent = status.dataset.error; }
        }, { signal });
        audio.addEventListener('play', () => {
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', button.dataset.pauseLabel);
          button.querySelector('.ftf-play-icon').textContent = 'Ⅱ';
        }, { signal });
        audio.addEventListener('pause', () => reset(audio), { signal });
        audio.addEventListener('ended', () => reset(audio), { signal });
        audio.addEventListener('error', () => { reset(audio); status.textContent = status.dataset.error; }, { signal });
      });
    }
    disconnectedCallback() {
      this.querySelectorAll('audio').forEach(audio => audio.pause());
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.revealObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

if (!customElements.get('ftf-community-audio')) {
  customElements.define('ftf-community-audio', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const audio = this.querySelector('audio');
      if (!audio) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const controls = this.querySelector('.ftf-track-controls');
      const button = controls.querySelector('button');
      const seek = controls.querySelector('input');
      const status = this.querySelector('[role=status]');
      const formatTime = seconds => {
        const safe = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
        return Math.floor(safe / 60) + ':' + String(safe % 60).padStart(2, '0');
      };
      const update = () => {
        const duration = audio.duration;
        const ready = Number.isFinite(duration) && duration > 0;
        seek.disabled = !ready;
        seek.max = ready ? String(duration) : '100';
        seek.value = String(audio.currentTime || 0);
        const elapsed = formatTime(audio.currentTime);
        const total = ready ? formatTime(duration) : '—:—';
        controls.querySelector('[data-elapsed]').textContent = elapsed;
        controls.querySelector('[data-duration]').textContent = total;
        seek.setAttribute('aria-valuetext', seek.dataset.positionTemplate.replace('__elapsed__', elapsed).replace('__total__', total));
      };
      const playbackState = () => {
        const playing = !audio.paused && !audio.ended;
        button.setAttribute('aria-pressed', String(playing));
        button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
        button.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
      };
      button.addEventListener('click', async () => {
        if (!audio.paused) {audio.pause(); return;}
        status.textContent = '';
        try {await audio.play();} catch (error) {if (error.name !== 'AbortError') status.textContent = status.dataset.error;}
      }, {signal});
      seek.addEventListener('input', () => {
        if (Number.isFinite(audio.duration)) audio.currentTime = Math.min(audio.duration, Number(seek.value));
        update();
      }, {signal});
      ['loadedmetadata','durationchange','timeupdate','emptied'].forEach(type => audio.addEventListener(type, update, {signal}));
      ['play','pause','ended'].forEach(type => audio.addEventListener(type, playbackState, {signal}));
      audio.addEventListener('error', () => {status.textContent = status.dataset.error;playbackState();}, {signal});
      update();
      controls.hidden = false;
      audio.controls = false;
      audio.hidden = true;
    }
    disconnectedCallback() {
      this.querySelector('audio')?.pause();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
